module.exports = __webpack_public_path__ + "img/remove.dc8a2982.png";